<template>
  <!-- 十九届以来的历次全会查看更多二级页 -->
  <div>
    <div class="ldmeet-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>党史学习</el-breadcrumb-item>
          <el-breadcrumb-item>十九大以来的历次全会</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ldmeet-cont">
        <div class="ldmeet-left">
          <LdddhNav></LdddhNav>
        </div>
        <div class="ldmeet-right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import LdddhNav from "./sjdyldlcqh/QHNav.vue";
export default {
  components: {
    LdddhNav,
  },
};
</script>
<style lang="scss" scoped>
  @import "../../assets/dmeet.css";
.ldmeet-content {
  width: 1200px;
  min-height: 1300px;
  margin: 30px auto;
  .ldmeet-cont {
    display: flex;
    margin-top: 20px;
    .ldmeet-left {
      width: 220px;
      height: auto;
    }
    .ldmeet-right {
      margin-left: 50px;
    }
  }
}
</style>